import { defineStore } from "pinia";

interface State {
	isLoading: boolean;
}
export const useHelpersStore = defineStore({
	id: "helpersStore",
	state: (): State => ({
		isLoading: false
	}),
	getters: {
		getIsLoading: (state) => state.isLoading
	},
	actions: {
		setIsLoading(isLoading: boolean) {
			this.isLoading = isLoading;
		}
	}
});
